import { Link, useLocation } from "react-router-dom";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import Container from "@mui/material/Container";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Utils from "../core/Utils";
import { LoginPage, OverviewPage } from "../core/PageConstants";
import { Stack } from "@mui/system";
import { Checkbox, FormControl, Input, MenuItem, Radio, Select } from "@mui/material";
import { useDispatch } from "react-redux";
import CountryHelper from "../core/CountryHelper";
import AddAPhotoIcon from "@mui/icons-material/AddAPhoto";
import { AlertSMSNotSupported, BusinessCategories, ConfirmTypes, India, MaxFileSizeLimit, UAE, USA, VehicleTypes } from "../core/Constants";
import DeleteIcon from "@mui/icons-material/Delete";
import { getCountry, getEnterpriseId, setToken, setLogin, setCountry } from "../data/localSettingsActions";
import UserHelper from "../core/UserHelper";
import { ImageEnlarge } from "./common/ImageEnlarge";
import ConfirmPopup from "./common/ConfirmPopup";
import AddressField from "./common/controls/AddressField";
import { getGeocodeAddress, postAsyncUnauthorized } from "../core/serviceClient";
import moment from "moment";
import MessagePopup from "./common/MessagePopUp";
import { Regexes } from "../core/Regexes";

const Register = () => {
  document.body.classList.add("login");
  document.title = "Register";
  const [LoginId, setId] = useState("");
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const [business, setBusiness] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [countryInfo, setCountryInfo] = useState("");
  const [msgOpen, setMsgOpen] = useState(false);
  const [msgText, setMsgText] = useState("");
  const [isNavigateToLogin, setIsNavigateToLogin] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const [confirmFor, setConfirmFor] = useState("");
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [confirmText, setConfirmText] = useState("");
  const [alertTitle, setAlertTitle] = useState("");

  const [enlargeImage, setEnlargeImage] = useState(false);
  const [businessImageFile, setBusinessImageFile] = useState(business.logoUrl);
  const [isAcceptedTC, setIsAcceptedTC] = useState(false);
  const [taxIdLabel, setTaxIdLabel] = useState("");
  const [countryName, setCountryName] = useState("");
  const [categories, setCategories] = useState("");
  const [registrationId, setRegistrationId] = useState("");
  const [stateCode, setStateCode] = useState("");
  const [website, setWebsite] = useState("");
  const [distributorCode, setDistributorCode] = useState("");
  const [referenceCode, setReferenceCode] = useState("");
  const [accountantEmailId, setAccountantEmailId] = useState("");
  const [accountantMobileNumber, setAccountantMobileNumber] = useState("");
  const [additionalPhoneNumber, setAdditionalPhoneNumber] = useState("");
  const [logoUrl, setLogoUrl] = useState("");
  const [facebookURL, setFacebookURL] = useState("");
  const [twitterURL, setTwitterURL] = useState("");
  const [instaURL, setInstaURL] = useState("");
  const [youtubeURL, setYoutubeURL] = useState("");
  const [justDialURL, setJustDialURL] = useState("");
  const [googleReviewURL, setGoogleReviewURL] = useState("");
  const [businessName, setBusinessName] = useState("");
  const [smsBusinessName, setSmsBusinessName] = useState("");
  const [selectedCategory, setSelectedCategory] = useState(BusinessCategories.Automobile);
  const [selectedSubCategory, setSelectedSubCategory] = useState("FourWheeler");
  const [addressISOCode, setAddressISOCode] = useState("");
  const [customerAddress, setCustomerAddress] = useState("");
  const [countries, setCountries] = useState([]);
  const [loginCountry, setLoginCountry] = useState({});
  const [selectedCountry, setSelectedCountry] = useState({});
  const [isCountryDisable, setIsCountryDisable] = useState(false);
  const [regIdLength, setRegIdLength] = useState(0);
  const [gst, setGST] = useState(false);


  useEffect(() => {

    if (!Utils.IsNullOrEmpty(location.state)) {
      let countryDetails = getCountry();
      if (location.state.loggedInWith === "Mobile") {
        setIsCountryDisable(true)
      }
      var countries = CountryHelper.GetSupportedCountries();
      if (!Utils.IsNullOrEmptyArray(countries)) {
        setCountries(countries);
        var index = Utils.GetIndex(India.Code, countries, "Code");
        var tempLoginCountry = countries[index > -1 ? index : 0];
        setLoginCountry(tempLoginCountry);
        var tempSelectedCountry = CountryHelper.GetCountryObject(tempLoginCountry.Code);
        setSelectedCountry(tempSelectedCountry);
        setCountryInfo(tempSelectedCountry, dispatch);
      }
      setBusinessCategory(countryDetails);
      let taxIdLbl = "Business Tax Id";
      if (countryDetails.ShortName === India.ShortName) taxIdLbl = "Business GSTIN";
      else if (countryDetails.ShortName === UAE.ShortName) taxIdLbl = "TRN No";
      setCountryDetails(countryDetails);
      setAddressISOCode(countryDetails.ISOCode);
      setCountryName(countryDetails.Name)
      setTaxIdLabel(taxIdLbl);
    }
    else {
      navigate(LoginPage.Path);
    }
  }, []);

  const setBusinessCategory = (countryDetails) => {

    var isVisible = countryDetails.ShortName == USA.ShortName ? false : true;
    var businessCategories = [
      {
        value: BusinessCategories.Automobile,
        isChecked: business.category == BusinessCategories.Automobile,
        isVisible: isVisible,
      },
      {
        value: BusinessCategories.Food,
        isChecked: business.category == BusinessCategories.Food,
        isVisible: !isVisible,
      },
      {
        value: BusinessCategories.Grocery,
        isChecked: business.category == BusinessCategories.Grocery,
        isChecked: false,
        isVisible: !isVisible,
      },
      {
        value: BusinessCategories.Salon,
        isChecked: business.category == BusinessCategories.Salon,
        isVisible: true,
      },
      {
        value: BusinessCategories.Other,
        isChecked: business.category == BusinessCategories.Other,
        isVisible: true,
      },
    ];
    setCategories(businessCategories);
  }





  const setCountryDetails = (country) => {
    setCountryInfo(country);
    setAddressISOCode(country.ISOCode);
    setBusinessCategory(country);
    var isIndia = CountryHelper.IsBusinessCountryIndia(country);
    var isUS = CountryHelper.IsBusinessCountryUSA(country);
    var isUAE = CountryHelper.IsBusinessCountryUAE(country);
    if (isIndia) {
      setGST(true);
      setRegIdLength(15);
      return;
    }
    if (isUS) {
      setGST(false);
      setRegIdLength(9);
      return;
    }
    if (isUAE) {
      setGST(false);
      setRegIdLength(15);
      return;
    }
  };


  const getLogoUrl = () => {
    var temp = "";
    var newFile = false;
    if (logoUrl.startsWith("http")) {
      temp = logoUrl.split("?")[0];
    } else if (!Utils.IsNullOrEmpty(logoUrl)) {
      temp = Utils.GetStringFromBase64(logoUrl);
      newFile = true;
    }
    return { logo: temp, newFile: newFile };
  };


  useEffect(() => {
    if (!Utils.IsNullOrEmpty(countryInfo)) {
      let taxIdLbl = "Business Tax Id";
      if (countryInfo.ShortName === India.ShortName) taxIdLbl = "Business GSTIN";
      else if (countryInfo.ShortName === UAE.ShortName) taxIdLbl = "TRN No";
      setTaxIdLabel(taxIdLbl);
      setAddressISOCode(countryInfo.ISOCode);
    }
  }, [loginCountry]);

  const NewBusinessRegistration = async (e) => {
    e.preventDefault();
    let errorMsg = "";
    if (Utils.IsNullOrEmpty(businessName)) {
      errorMsg += "Please enter the business name.<br />";
    }
    if (!Utils.IsNullOrEmpty(website)) {
      if (!Utils.IsURLValid(website))
        errorMsg = "Please enter the valid website address.<br />";
    }
    if (Utils.IsNullOrEmpty(selectedCategory)) {
      errorMsg = "Please select Category.<br />";
    }
    if (Utils.IsNullOrEmpty(businessName)) {
      errorMsg = "Please enter the Business Name.<br />";
    }
    if (Utils.IsNullOrEmpty(customerAddress)) {
      errorMsg = "Please enter the Address .<br />";
    }
    if (Utils.IsNullOrEmpty(smsBusinessName) && !CountryHelper.IsBusinessCountryMalaysia(countryInfo)) {
      errorMsg = "Please enter the SMS Business Name.<br />";
    }
    if (Utils.IsNullOrEmpty(selectedSubCategory) && selectedCategory === "Automobile") {
      errorMsg = "Please select vehicle type.<br />";
    }
    if (!Utils.IsNullOrEmpty(registrationId)) {
      var validRegistrationId = Utils.IsNullOrEmpty(registrationId);
      if (!validRegistrationId && CountryHelper.IsBusinessCountryIndia(countryInfo)) {
        validRegistrationId =
          registrationId.length === regIdLength &&
          Regexes.GST.test(registrationId);
      } else if (!validRegistrationId) {
        validRegistrationId = registrationId.length === regIdLength;
      }
      if (!validRegistrationId)
        errorMsg += "Please enter the valid " + taxIdLabel + ".<br />";
    }
    if (!isVisible && !Utils.IsNullOrEmpty(accountantMobileNumber)) {
      if (!Utils.IsMobileValid(accountantMobileNumber))
        errorMsg += "Please enter the valid mobile number.<br />";
    }
    if (!Utils.IsNullOrEmpty(facebookURL)) {
      if (!Utils.IsURLValid(facebookURL))
        errorMsg += "Please enter the valid facebook url.<br />";
    }
    if (!Utils.IsNullOrEmpty(instaURL)) {
      if (!Utils.IsURLValid(instaURL))
        errorMsg += "Please enter the valid instagram url.<br />";
    }
    if (!Utils.IsNullOrEmpty(twitterURL)) {
      if (!Utils.IsURLValid(twitterURL))
        errorMsg += "Please enter the valid twitter url.<br />";
    }
    if (!Utils.IsNullOrEmpty(youtubeURL)) {
      if (!Utils.IsURLValid(youtubeURL))
        errorMsg += "Please enter the valid youtube url.<br />";
    }
    if (!Utils.IsNullOrEmpty(justDialURL)) {
      if (!Utils.IsURLValid(justDialURL))
        errorMsg += "Please enter the valid justDial url.<br />";
    }
    if (!Utils.IsNullOrEmpty(googleReviewURL)) {
      if (!Utils.IsURLValid(googleReviewURL))
        errorMsg += "Please enter the valid google review url.<br />";
    }
    if (!Utils.IsNullOrEmpty(errorMsg)) {
      setMsgText(errorMsg);
      setMsgOpen(true);
    } else {
      var addressDetails = null;
      if (!Utils.IsNullOrEmpty(customerAddress)) {
        var geocodeResponse = await getGeocodeAddress(customerAddress);
        if (!Utils.IsNullOrEmptyObject(geocodeResponse) && geocodeResponse.error) {
          setIsLoading(false);
          setMsgOpen(true);
          setMsgText(geocodeResponse.errorMessage);
          return;
        }
        if (
          !Utils.IsNullOrEmptyObject(geocodeResponse) &&
          geocodeResponse.status === "OK"
        ) {
          var locality = "";
          var county = "";
          var state = "";
          var country = "";
          var zipcode = "";
          var streetNumber = "";
          var route = "";
          var address = "";
          var lng = 0;
          var lat = 0;
          address = geocodeResponse.results[0].formatted_address;
          if (
            geocodeResponse.results[0].address_components
              .map((c) => c.types)
              .reduce((a, b) => a.concat(b))
              .includes("street_number") === true
          ) {
            var ac = geocodeResponse.results[0].address_components.find((c) =>
              c.types.includes("street_number")
            );
            if (!Utils.IsNullOrEmptyObject(ac)) {
              streetNumber = ac.long_name;
            }
          }

          if (
            geocodeResponse.results[0].address_components
              .map((c) => c.types)
              .reduce((a, b) => a.concat(b))
              .includes("route") === true
          ) {
            var ac = geocodeResponse.results[0].address_components.find((c) =>
              c.types.includes("route")
            );
            if (!Utils.IsNullOrEmptyObject(ac)) {
              route = ac.long_name;
            }
          }

          if (
            geocodeResponse.results[0].address_components
              .map((c) => c.types)
              .reduce((a, b) => a.concat(b))
              .includes("locality") === true
          ) {
            var ac = geocodeResponse.results[0].address_components.find((c) =>
              c.types.includes("locality")
            );
            if (!Utils.IsNullOrEmptyObject(ac)) {
              locality = ac.long_name;
            }
          }

          if (
            geocodeResponse.results[0].address_components
              .map((c) => c.types)
              .reduce((a, b) => a.concat(b))
              .includes("administrative_area_level_1") === true
          ) {
            var ac = geocodeResponse.results[0].address_components.find((c) =>
              c.types.includes("administrative_area_level_1")
            );
            if (!Utils.IsNullOrEmptyObject(ac)) {
              state = ac.long_name;
            }
          }

          if (
            geocodeResponse.results[0].address_components
              .map((c) => c.types)
              .reduce((a, b) => a.concat(b))
              .includes("administrative_area_level_2") === true
          ) {
            var ac = geocodeResponse.results[0].address_components.find((c) =>
              c.types.includes("administrative_area_level_2")
            );
            if (!Utils.IsNullOrEmptyObject(ac)) {
              county = ac.long_name;
            }
          }

          if (
            geocodeResponse.results[0].address_components
              .map((c) => c.types)
              .reduce((a, b) => a.concat(b))
              .includes("country") === true
          ) {
            var ac = geocodeResponse.results[0].address_components.find((c) =>
              c.types.includes("country")
            );
            if (!Utils.IsNullOrEmptyObject(ac)) {
              country = ac.short_name;
            }
          }

          if (
            geocodeResponse.results[0].address_components
              .map((c) => c.types)
              .reduce((a, b) => a.concat(b))
              .includes("postal_code") === true
          ) {
            var ac = geocodeResponse.results[0].address_components.find((c) =>
              c.types.includes("postal_code")
            );
            if (!Utils.IsNullOrEmptyObject(ac)) {
              zipcode = ac.long_name;
            }
          }
          console.log(navigator)
          lat = geocodeResponse.results[0].geometry.location.lat;
          lng = geocodeResponse.results[0].geometry.location.lng;
          addressDetails = {
            HomeLocation: customerAddress,
            Address: streetNumber + " " + route,
            City: locality,
            State: state,
            Country: country,
            County: county,
            ZipCode: zipcode,
            Locality: locality,
            Latitude: Utils.ConvertToFloat(lat),
            Longitude: Utils.ConvertToFloat(lng),
          };
        } else {
          setIsLoading(false);
          setMsgOpen(true);
          setMsgText("Invalid address");
          return;
        }
      }
      const imgObj = getLogoUrl();
      let enterpriseId = getEnterpriseId();
      var cCode = CountryHelper.GetCountryCode(loginCountry)
      var vehicleType = selectedCategory === BusinessCategories.Automobile ? selectedSubCategory : VehicleTypes.None;
      var defaultBranch = {
        serviceStartTime: Utils.GetISODateTimeString(moment().add(8, 'hours')),
        serviceEndTime: Utils.GetISODateTimeString(moment().add(1, 'hours')),
        address: customerAddress,
        contactEmailId: location.state.loggedInWith === "Mobile" ? "" : location.state.loginid,
        contactPhoneNumber: location.state.loggedInWith === "Mobile" ? location.state.loginid : accountantMobileNumber,
        additionalPhoneNumber: additionalPhoneNumber,
        registrationId: registrationId,
        branchId: (1).toString().padStart(3, '0'),
        branchName: businessName,
        contactName: businessName,
        reserveProducts: false,
        countryCode: cCode.Code,
        country: cCode.ShortName,
        reservationsDisabled: true,
        vehicleType: vehicleType,
        latitude: lat,
        longitude: lng,
      }

      var businessEntityConfiguration = {
        accountantEmailId: location.state.loggedInWith === "Mobile" ? "" : location.state.loginid,
        accountantMobileNumber: location.state.loggedInWith === "Mobile" ? location.state.loginid : accountantMobileNumber,
        accountantName: location.state.customerName,
        authMode: "OTP",
        category: selectedCategory,
        companyName: businessName,
        currency: cCode.Currency,
        logoUrl: imgObj.logo,
        registrationId: registrationId,
        vertical: "Retail",
        website: website,
        stateCode: stateCode,
        distributorCode: distributorCode,
        facebookUrl: facebookURL,
        instaUrl: instaURL,
        twitterUrl: twitterURL,
        youtubeUrl: youtubeURL,
        justDialUrl: justDialURL,
        googleReviewUrl: googleReviewURL,
        enterpriseId: enterpriseId,
        enterpriseCode: enterpriseId,
        sMSComapnyName: smsBusinessName,
        branchLocations: [defaultBranch]
      }

      var defaultUser = {
        emailId: location.state.loggedInWith === "Mobile" ? "" : location.state.loginid,
        firstName: businessName,
        userName: businessName,
        lastName: "",
        mobileNumber: location.state.loggedInWith === "Mobile" ? location.state.loginid : accountantMobileNumber,
        additionalPhoneNumber: additionalPhoneNumber,
        id: location.state.loggedInWith === "Email" ? location.state.loginid : accountantMobileNumber,
        logInWith: location.state.loggedInWith,
        branchId: defaultBranch.branchId,
        active: true,
        pOSId: "100",
        countryCode: cCode.Code,
        deviceName: "Webapp",
        devicePlatform: "Webapp",
        deviceVersion: "Webapp",
        enterpriseId: enterpriseId,
        enterpriseCode: enterpriseId
      };
      var newBusiness = {
        business: businessEntityConfiguration,
        deviceName: "Webapp",
        devicePlatform: "Webapp",
        defaultBrancheviceVersion: "Webapp",
        manufacturer: "Webapp",
        model: "Webapp",
        secret: "Webapp",
        user: defaultUser,
        referenceCode: referenceCode,
        testMode: false,
      }
      var result = await postAsyncUnauthorized("Auth/RegisterBusinessForWeb", newBusiness)
      setIsLoading(false);
      if (result.error) {
        setMsgOpen(true);
        setMsgText(result.errorMessage);
        return;
      }
      else {
        setToken(result.data.token, dispatch);
        setLogin(result.data, dispatch);
        navigate(OverviewPage.Path);
      }
    }

  }


  const UploadBusinessImage = async (event) => {
    var file = event.target.files[0];
    setBusinessImageFile(file);
    if (file.size > MaxFileSizeLimit) {
      setAlertTitle("Warning");
      setMsgText(
        "Unable to upload. File size exceeds the maximum limit, please ensure that it's less than 10 MB."
      );
      setMsgOpen(true);
      return;
    }
    var base64 = await convertBase64(file);
    setLogoUrl(base64);
  };

  const convertBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(file);
      fileReader.onload = () => {
        resolve(fileReader.result);
      };
      fileReader.onerror = (error) => {
        reject(error);
      };
    });
  };
  const openImage = () => {
    setEnlargeImage(true);
  };

  const deleteBusinessPhoto = () => {
    setConfirmFor("DeletePhoto");
    setConfirmText("Deleted images cannot be restored. Are you sure?");
    setConfirmOpen(true);
  };
  const handleCloseConfirm = async (value) => {
    setConfirmOpen(false);
    switch (value) {
      case ConfirmTypes.OK:
      case ConfirmTypes.YES:
        setLogoUrl("");
        break;
    }
  };
  const handleConfirmClose = (value) => {
    setConfirmOpen(false);

    if (value == ConfirmTypes.OK) {
      if (confirmFor == "Update") {
        //updateBusiness();
      } else if (confirmFor == "Delete") {
        //deleteBusiness();
      } else if (confirmFor == "DeletePhoto") {
        handleCloseConfirm(value);
      }
    }
  };

  const closeImage = () => {
    setEnlargeImage(false);
  };


  const handleCategoryChange = (category) => {
    setSelectedCategory(category);
    if (category !== BusinessCategories.Automobile) {
      setSelectedSubCategory("");
    }
  };

  const handleSubCategoryChange = (sub) => {
    setSelectedSubCategory(sub);
  };

  const onSelectCountry = (event) => {
    var tempCountry = event.target.value;
    var countryObj = CountryHelper.GetCountryObject(tempCountry.Code);
    if (!countryObj.SMSEnabled && location.state.loggedInWith === "Mobile") {
      setMsgOpen(true);
      setMsgText(AlertSMSNotSupported);
      return;
    }
    setCountryDetails(countryObj)
    setSelectedCountry(countryObj);
    setCountry(countryObj, dispatch);
    setLoginCountry(tempCountry);
  };
  const handleMsgClose = () => {
    setMsgOpen(false);
    if (isNavigateToLogin) {
      UserHelper.LogOut(dispatch);
      navigate(LoginPage.Path);
    }
  };

  return (
    <Container maxWidth="false" className="bg-color p-0">
      <Grid className="container">
        <MessagePopup
          msgOpen={msgOpen}
          msgText={msgText}
          onMsgClose={handleMsgClose}
        />
        <ConfirmPopup
          confirmOpen={confirmOpen}
          confirmText={confirmText}
          onConfirmClose={handleConfirmClose}
        />
        <ImageEnlarge open={enlargeImage} imgSrc={logoUrl} onClose={closeImage} />
        <Grid xs={12} md={9}>
          <Grid spacing={2} className="form-sec">
            <Stack sx={{ minWidth: 120 }} spacing={2}
              className="cs-form text-left">
              <FormControl fullWidth>
                <Select
                  labelId="country-label"
                  className="country-option"
                  id="country"
                  value={loginCountry}
                  disabled={isCountryDisable}
                  variant="outlined"
                  onChange={(e) => onSelectCountry(e)}
                >
                  {!Utils.IsNullOrEmptyArray(countries) &&
                    countries.map((country) => (
                      <MenuItem s value={country}>
                        {country.Name}
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>

              {!gst ? (
                <>
                  <FormControl fullWidth>
                    <TextField
                      id="registrationId"
                      label={taxIdLabel}
                      variant="outlined"
                      inputProps={{ maxLength: regIdLength }}
                      value={registrationId}
                      onChange={(e) => setRegistrationId(e.target.value)}
                    />
                  </FormControl>
                </>
              ) : (
                <>
                  <FormControl fullWidth className="my-xs-1">
                    <TextField
                      id="registrationId"
                      label={taxIdLabel}
                      variant="outlined"
                      value={registrationId}
                      error={Utils.IsNullOrEmpty(registrationId) ? false : !Regexes.GST.test(registrationId)}
                      onChange={(e) => setRegistrationId(e.target.value)}
                    />
                  </FormControl>

                  <FormControl fullWidth>
                    <TextField
                      id="GSTNStateCode"
                      label="GSTN State Code"
                      variant="outlined"
                      value={stateCode}
                      inputProps={{ maxLength: 30 }}
                      onChange={(e) => setStateCode(e.target.value)}
                      placeholder="Enter code"
                    />
                  </FormControl>
                </>
              )}
              <FormControl fullWidth>
                <TextField
                  id="Business Name"
                  label="Business Name"
                  variant="outlined"
                  error={!businessName}
                  value={businessName}
                  onChange={(e) => setBusinessName(e.target.value)}
                  placeholder="Enter Business Name"
                />
              </FormControl>
              {!CountryHelper.IsBusinessCountryMalaysia(countryInfo) && (
                < FormControl fullWidth>
                  <TextField
                    id="SMS Business Name"
                    label="SMS Business Name"
                    variant="outlined"
                    error={!smsBusinessName}
                    value={smsBusinessName}
                    onChange={(e) => setSmsBusinessName(e.target.value)}
                    placeholder="Enter SMS Business Name"
                  />
                </FormControl>
              )}

              <FormControl fullWidth>

                {!Utils.IsNullOrEmpty(addressISOCode) && (<AddressField
                  id="branchAddress"
                  variant="outlined"
                  label="Branch Address"
                  required
                  isValidate={true}
                  countryISoCode={addressISOCode}
                  value={customerAddress}
                  setValue={setCustomerAddress}
                />)}
              </FormControl>

              <FormControl fullWidth>
                <TextField
                  id="mobileNumber"
                  label="Mobile Number"
                  variant="outlined"
                  error={!accountantMobileNumber}
                  inputProps={{ maxLength: CountryHelper.GetMobileNumberMaxLength() }}
                  value={accountantMobileNumber}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (value !== "" && !/[0-9]/.test(value)) {
                      return;
                    }
                    setAccountantMobileNumber(value);
                  }}
                  placeholder="Enter mobile number"
                />
              </FormControl>

              <FormControl fullWidth>
                <TextField
                  id="additionalPhoneNumber"
                  label="Addtional Phone Number"
                  variant="outlined"
                  inputProps={{ maxLength: CountryHelper.GetMobileNumberMaxLength() }}
                  value={additionalPhoneNumber}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (value !== "" && !/[0-9]/.test(value)) {
                      return;
                    }
                    setAdditionalPhoneNumber(value);
                  }}
                  placeholder="Enter Addtional Phone Number"
                />
              </FormControl>

              <FormControl fullWidth>
                <TextField
                  id="website"
                  label="Website Address"
                  variant="outlined"
                  value={website}
                  onChange={(e) => setWebsite(e.target.value)}
                  placeholder="Enter website address"
                />
              </FormControl>

              <FormControl fullWidth>
                <Stack direction="row" alignItems="center" spacing={2} flexWrap="wrap">
                  <Typography level="h3" component="h3" fontWeight="600" fontSize="1.5rem">
                    Category
                  </Typography>

                  {!Utils.IsNullOrEmptyArray(categories) &&
                    categories.map((item, index) => {
                      if (item.isVisible) {
                        return (
                          <Stack direction="row" alignItems="center" key={index} spacing={1}>
                            <Radio
                              checked={selectedCategory === item.value}
                              onChange={() => handleCategoryChange(item.value)}
                            />
                            <Typography level="h4" component="h4" fontSize="1.5rem">
                              {item.value}
                            </Typography>
                          </Stack>
                        );
                      }
                      return null;
                    })}
                </Stack>

                {selectedCategory === BusinessCategories.Automobile && (
                  <Stack direction="row" alignItems="center" spacing={2} mt={2}>
                    <Typography level="h5" component="h5" fontWeight="500" fontSize="1.3rem">
                      Sub Category:
                    </Typography>

                    <Stack direction="row" spacing={2}>
                      <Stack direction="row" alignItems="center" spacing={1}>
                        <Radio
                          checked={selectedSubCategory === "TwoWheeler"}
                          onChange={() => handleSubCategoryChange("TwoWheeler")}
                        />
                        <Typography level="h4" component="h4" fontSize="1.5rem">Two Wheeler</Typography>
                      </Stack>

                      <Stack direction="row" alignItems="center" spacing={1}>
                        <Radio
                          checked={selectedSubCategory === "FourWheeler"}
                          onChange={() => handleSubCategoryChange("FourWheeler")}
                        />
                        <Typography level="h4" component="h4" fontSize="1.5rem">Four Wheeler</Typography>
                      </Stack>
                    </Stack>
                  </Stack>
                )}
              </FormControl>







              <Stack direction="row" spacing={2}>

              </Stack>
              <Typography
                level="h3"
                component="h3"
                fontWeight="600"
                fontSize="1.5rem"
                className="h3"
              >
                Logo For Business
              </Typography>
              {Utils.IsNullOrEmpty(logoUrl) && (
                <Stack direction="row">
                  <label>
                    <AddAPhotoIcon fontSize="large" />
                    <Input
                      type="file"
                      name="myImage"
                      className="hide"
                      inputProps={{
                        accept:
                          "image/png, image/jpeg, image/ico, image/jpg",
                      }}
                      onChange={(e) => UploadBusinessImage(e)}
                    />
                  </label>
                </Stack>
              )}

              {!Utils.IsNullOrEmpty(logoUrl) && (
                <Grid className="card imgBox">
                  <img
                    alt="not found"
                    width={"150px"}
                    src={logoUrl}
                    onClick={openImage}
                  />
                  <br />
                  <button
                    className="p-0 mt-1 btn btn-default"
                    onClick={deleteBusinessPhoto}
                  >
                    <DeleteIcon />
                  </button>
                </Grid>
              )}

              {isVisible && (
                <FormControl fullWidth>
                  <TextField
                    id="distributorCode"
                    label="Distributor Code"
                    variant="outlined"
                    value={distributorCode}
                    disabled
                    onChange={(e) => setDistributorCode(e.target.value)}
                  />
                </FormControl>
              )}
              <FormControl fullWidth>
                <TextField
                  id="referenceCode"
                  label="Reference Code"
                  variant="outlined"
                  value={referenceCode}
                  onChange={(e) => setReferenceCode(e.target.value)}
                  placeholder="Enter Reference Code"
                />
              </FormControl>
              <FormControl fullWidth>
                <TextField
                  id="facebookURL"
                  label="Facebook URL"
                  variant="outlined"
                  value={facebookURL}
                  onChange={(e) => setFacebookURL(e.target.value)}
                  placeholder="Enter url"
                />
              </FormControl>
              <FormControl fullWidth>
                <TextField
                  id="instagramURL"
                  label="Instagram URL"
                  variant="outlined"
                  value={instaURL}
                  onChange={(e) => setInstaURL(e.target.value)}
                  placeholder="Enter url"
                />
              </FormControl>
              <FormControl fullWidth>
                <TextField
                  id="twitterURL"
                  label="Twitter URL"
                  variant="outlined"
                  value={twitterURL}
                  onChange={(e) => setTwitterURL(e.target.value)}
                  placeholder="Enter url"
                />
              </FormControl>
              <FormControl fullWidth>
                <TextField
                  id="youtubeURL"
                  label="Youtube URL"
                  variant="outlined"
                  value={youtubeURL}
                  onChange={(e) => setYoutubeURL(e.target.value)}
                  placeholder="Enter url"
                />
              </FormControl>
              <FormControl fullWidth>
                <TextField
                  id="justDialURL"
                  label="JustDial URL"
                  variant="outlined"
                  value={justDialURL}
                  onChange={(e) => setJustDialURL(e.target.value)}
                  placeholder="Enter url"
                />
              </FormControl>
              <FormControl fullWidth>
                <TextField
                  id="googleReviewURL"
                  label="Google Review URL"
                  variant="outlined"
                  value={googleReviewURL}
                  onChange={(e) => setGoogleReviewURL(e.target.value)}
                  placeholder="Enter url"
                />
              </FormControl>

              <Stack
                direction="row"
                className="fixed-btn"
              >
                <Grid className="container"
                  justifyContent="end"
                >
                  <Stack direction="row" justifyContent="end">
                    <Stack direction="row" alignItems={"center"} className="mr-2 font-size-14">
                      <Checkbox
                        checked={isAcceptedTC}
                        onChange={(e) => setIsAcceptedTC(e.target.checked)}
                      />
                      <Link
                        to={CountryHelper.GetTermsAndConditionUrl()}
                        target="_blank"
                      >
                        <Typography
                          level="p"
                          component="p"
                        >
                          I accept the terms and conditions
                        </Typography>
                      </Link>
                    </Stack>
                    <Stack
                      direction="row"
                      spacing={2}
                      justifyContent="flex-end"
                      alignSelf="end"
                    >
                      {/* <FormControl>
                                  <Button
                                    variant="contained"
                                    color="error"
                                    onClick={() => deleteBusinessClick()}
                                  >
                                    Delete
                                  </Button>
                                </FormControl> */}
                      <FormControl>
                        <Button
                          type="submit"
                          variant="contained"
                          className="btn btn-primary"
                          onClick={NewBusinessRegistration}
                          disabled={!isAcceptedTC}
                        >
                          Save
                        </Button>
                      </FormControl>
                    </Stack>
                  </Stack>
                </Grid>
              </Stack>
            </Stack>
          </Grid>
        </Grid>
      </Grid>
    </Container >
  );
};

export default Register;
